import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showTable: false
};

const topupSlice = createSlice({
  name: 'topup',
  initialState,
  reducers: {
    toggleShowTable: (state, { payload }) => {
      state.showTable = payload;
    }
  }
});

export const { reducer, actions: topupSliceActions } = topupSlice;
